import React from 'react';
import {
  LineChart as RechartsLineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface MultiLineChartProps {
  data: Array<{
    date: string;
    allCompanies: number;
    selectedCompany?: number;
  }>;
  title?: string;
  allCompaniesLabel?: string;
  selectedCompanyLabel?: string;
  allCompaniesColor?: string;
  selectedCompanyColor?: string;
  height?: number;
}

export const MultiLineChart: React.FC<MultiLineChartProps> = ({
  data,
  title,
  allCompaniesLabel = 'All Companies',
  selectedCompanyLabel = 'Selected Company',
  allCompaniesColor = '#82ca9d',
  selectedCompanyColor = '#ff7300',
  height = 300,
}) => {
  return (
    <div style={{ width: '100%', height }}>
      {title && <h3 style={{ marginBottom: '16px' }}>{title}</h3>}
      <ResponsiveContainer width="100%" height="100%">
        <RechartsLineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="allCompanies"
            name={allCompaniesLabel}
            stroke={allCompaniesColor}
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
          />
          {data.some(d => d.selectedCompany !== undefined) && (
            <Line
              type="monotone"
              dataKey="selectedCompany"
              name={selectedCompanyLabel}
              stroke={selectedCompanyColor}
              strokeWidth={3}
              dot={{ r: 5 }}
              activeDot={{ r: 7 }}
            />
          )}
        </RechartsLineChart>
      </ResponsiveContainer>
    </div>
  );
};


